<template>
    <div class="reverve-box app">
      <div class="reverve-out">
        <van-cell-group>
          <van-field v-model="ruleForm.name" required input-align="right" label="姓名" placeholder="请输入姓名"/>
        </van-cell-group>
        <div class="team">
          <van-cell-group>
            <van-field readonly is-link
              clickable input-align="right"
              label="性别" :value="sexName"
              placeholder="请选择性别" @click="onShowSex"
            />
          </van-cell-group>
          <!-- 选择性别 -->
          <div v-if="myIf1">
            <van-popup v-model="showSex" position="bottom">
              <van-picker
                show-toolbar
                :columns="sexColumns"
                @cancel="showSex = false"
                @confirm="onConfirmSex"
              />
            </van-popup>
          </div>
        </div>
        <div class="team">
          <van-cell-group>
            <van-field
              readonly required clickable
              input-align="right" is-link
              label="预约时间"
              :value="dateName"
              placeholder="请选择就诊日期"
              @click="onShowDate"
            />
          </van-cell-group>
          <!-- 选择时间 -->
          <div v-if="myIf2">
            <van-popup v-model="showDate" position="bottom">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                :min-date="minDate"
                @cancel="showDate = false"
                @confirm="onConfirmDate"
              />
            </van-popup>
          </div>
        </div>
        <div class="team">
          <van-cell-group>
            <van-field
              readonly required
              clickable is-link
              input-align="right"
              label="时段"
              :value="dateTypeName"
              placeholder="请选择时段"
              @click="onShowDateType"
            />
          </van-cell-group>
          <!-- 选择时间段 -->
          <div v-if="myIf3">
            <van-popup v-model="showDateType" position="bottom">
              <van-picker
                show-toolbar
                :columns="dateTypeColumns"
                @cancel="showDateType = false"
                @confirm="onConfirmDateType"
              />
            </van-popup>
          </div>
        </div>
        <van-cell-group>
          <van-field v-model="ruleForm.mobile" required input-align="right" type="tel" label="手机号码" placeholder="请输入手机号码" />
        </van-cell-group>
        <div class="team">
          <van-cell-group>
            <van-field
              readonly required
              clickable
              is-link
              input-align="right"
              label="病症列表"
              :value="illnessName"
              placeholder="请选择病症列表"
              @click="onShowIllness"
            />
          </van-cell-group>
          <!-- 选择病症列表 -->
          <div v-if="myIf4">
            <van-popup v-model="showIllness" position="bottom" lock-scroll>
              <van-picker
                show-toolbar
                :columns="illnessColumns"
                @cancel="showIllness = false"
                @confirm="onConfirmIllness"
              />
            </van-popup>
          </div>
        </div>
        <van-cell-group>
          <van-field
            v-model="ruleForm.description"
            rows="3"
            input-align="right"
            label="病症描述"
            type="textarea"
            maxlength="100"
            placeholder="请填写（选填）"
            show-word-limit
          />
        </van-cell-group>
        <van-cell-group>
          <van-cell title="期望院区" :value="hospital_name" />
        </van-cell-group>
        <van-cell-group>
          <van-cell title="期望医生" :value="ruleForm.doctor" />
        </van-cell-group>
      </div>
      <div class="submit-box">
        <van-button type="default" class="fwb fs16 submitBtn" @click="onClickButtonSubmit">提交预约</van-button>
      </div>
    </div>
</template>

<script>
import { Picker,Field,Popup,Cell, CellGroup,DatetimePicker,Button,Checkbox, CheckboxGroup} from 'vant';
export default {
    components: {
      [Picker.name]:Picker,
      [Field.name]:Field,
      [Popup.name]:Popup,
      [Cell.name]:Cell,
      [CellGroup.name]:CellGroup,
      [DatetimePicker.name]:DatetimePicker,
      [Button.name]:Button,
      [Checkbox.name]:Checkbox,
      [CheckboxGroup.name]:CheckboxGroup
    },
    data() {
      return {
        myIf1:false,
        myIf2:false,
        myIf3:false,
        myIf4:false,
        sexName:'',
        showSex:false,
        sexColumns: [
          { text: '男',id:'0' },
          { text: '女',id:'1' },
        ],
        dateTypeName:'',
        showDateType:false,
        dateTypeColumns: [
          { text: '全天',id:'0' },
          { text: '上午',id:'1' },
          { text: '下午',id:'2' }
        ],
        dateName:'',
        showDate:false,
        currentDate: new Date(),
        minDate:'',
        illnessName:'',
        showIllness:false,
        illnessColumns:[],
        illnessArr:[],
        ruleForm: {
          sub_hospital_id:this.$route.params.sub_hospital_id,
          hospital_id:this.$route.params.hospital_id,
          branch_id:this.$route.params.branch_id,
          name: '',
          sex: '',
          date: '',
          date_type:'',
          mobile:'',
          illness: '',
          description: '',
          doctor:this.$route.params.name
        },
        hospital_name:this.$route.params.hospital_name,
      }
    },
    methods: {
      onShowSex(){
        this.myIf1 = true
        this.myIf2 = false
        this.myIf3 = false
        this.myIf4 = false
        this.showSex=true;
      },
      onShowDate(){
        this.myIf1 = false
        this.myIf2 = true
        this.myIf3 = false
        this.myIf4 = false
        this.showDate=true;
      },
      onShowDateType(){
        this.myIf1 = false
        this.myIf2 = false
        this.myIf3 = true
        this.myIf4 = false
        this.showDateType=true;
      },
      onShowIllness(){
        this.myIf1 = false
        this.myIf2 = false
        this.myIf3 = false
        this.myIf4 = true
        this.showIllness=true;
      },
      onConfirmSex(value) {
        this.sexName=value.text
        this.ruleForm.sex = value.id;
        this.showSex = false;
        this.myIf1=false;
      },
      onConfirmDateType(value) {
        this.dateTypeName=value.text
        this.ruleForm.date_type = value.id;
        this.showDateType = false;
        this.myIf2=false;
      },
      onConfirmDate(value){
        this.dateName=value.toLocaleDateString().replace(/\//g, "-");
        this.ruleForm.date = value.getTime()/1000;
        this.showDate = false;
        this.myIf3=false;
      },
      onConfirmIllness(value){
        this.illnessName=value;
        this.ruleForm.illness=value;
        this.showIllness = false;
        this.myIf4=false;
      },
      onClickButtonSubmit(){
        if(this.ruleForm.name == ''){
          this.$toast("姓名不能为空");
          return false;
        }
        if(this.ruleForm.date == ''){
          this.$toast("预约时间不能为空");
          return false;
        }
        if(this.ruleForm.date_type == ''){
          this.$toast("预约时段不能为空");
          return false;
        }
        if(this.ruleForm.mobile == ''){
          this.$toast("手机号码不能为空");
          return false;
        }
        if(this.ruleForm.mobile){
          var phone = this.ruleForm.mobile;
          if(!(/^1[3456789]\d{9}$/.test(phone))){ 
              this.$toast("手机号码有误，请重填");  
              return false; 
          } 
        }
        if(this.ruleForm.illness.length == 0){
          this.$toast("病症列表不能为空");
          return false;
        }
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
        this.$axios.post(this.api.doctorGroup.reservation,this.ruleForm,res =>{
          this.$toast.success(res.msg);
          this.ruleForm={
            sub_hospital_id:this.$route.params.sub_hospital_id,
            hospital_id:this.$route.params.hospital_id,
            branch_id:this.$route.params.branch_id,
            name: '',
            sex: '',
            date: '',
            date_type:'',
            mobile:'',
            illness: '',
            description: '',
            doctor:this.$route.params.name
          }
          this.sexName='';
          this.dateName='';
          this.dateTypeName='';
          this.illnessName='';
          this.illnessArr=[]
        });
      },
      getTomorrow(){
        // 获取后天的日期并且赋值
        var dd = new Date();
        dd.setDate(dd.getDate()+2);//获取AddDayCount天后的日期
        var year=dd.getFullYear();  // 获取完整的年份(4位,1970)
        var month=dd.getMonth();  // 获取月份(0-11,0代表1月,用的时候记得加上1),这个控件不用加1
        var day=dd.getDate();  // 获取日(1-31)
        this.minDate=new Date(year,month,day);
      }
    },
    created(){
        this.getTomorrow();
        this.$axios.post(this.api.doctorGroup.symptomList,{branch_id:this.ruleForm.branch_id},res =>{
            let dataList=res.data.result || [];
            let result=[];

            dataList.filter((item) => {
              result.push(item.symptom_name);
            });
            
            this.illnessColumns=result;
        });
        // input 键盘焦点问题修复

        window.addEventListener('resize', () => {
          const activeElement = document.activeElement
          if (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA') {
            setTimeout(() => {
              activeElement.scrollIntoView()
            }, 100)
            }
        })
    }
  }
</script>

<style scoped lang="less">
.reverve-box .reverve-out{
  background:#fff;
  padding-left:16px;
  .illness-li{
    height:54px;
    line-height:54px;
    padding-left:16px;
    border-bottom:1px solid #EBEBED;
  }
  .illness-li:last-child{border-bottom:none;}
}
.submit-box{
  padding-left:16px;
  text-align: center;
  margin-top:32px;
  .submitBtn{
    width:240px;
    height:44px;
    background:rgba(13,52,130,1);
    border-radius:27px;
    color:#fff;
    line-height:44px;
  }
}

</style>
<style>
.van-picker__cancel, .van-picker__confirm{color:#0D3482;}
.reverve-box .van-cell{padding:16px;}
.van-checkbox__icon--checked .van-icon{
  background-color: #0D3482;
  border-color: #0D3482;
}
</style>



// WEBPACK FOOTER //
// src/view/doctors/Reserve.vue